var render = function () {
  var _vm$chargingStation;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report', {
    attrs: {
      "renderBackAndForthFooter": false,
      "isProgressDone": true,
      "showFooter": false
    }
  }, [_c('v-card-title', {
    staticClass: "text-h4 px-0 text-truncate"
  }), !_vm.isLoading ? _c('v-container', {
    staticClass: "padded"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pl-0"
  }, [_c('a', {
    on: {
      "click": _vm.goToChargingStationOverview
    }
  }, [_c('v-icon', [_vm._v("mdi-menu-left")]), _vm._v(_vm._s(_vm.$t("components.thg.ThgChargingStationDetail.back")))], 1)]), _c('v-card-title', {
    staticClass: "text-h4 px-0 text-truncate"
  }, [_vm._v(" " + _vm._s((_vm$chargingStation = _vm.chargingStation) === null || _vm$chargingStation === void 0 ? void 0 : _vm$chargingStation.name) + " ")]), _c('v-card-subtitle', {
    staticClass: "pl-0"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.thg.ThgChargingStationDetail.created", {
    date: _vm.chargingStationTimeStamp
  })))])], 1)], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('thg-charging-station-card', {
    attrs: {
      "selection": _vm.chargingStation,
      "meterReadings": _vm.meterReadings,
      "loading": _vm.isLoading
    }
  }), _c('Debug', {
    attrs: {
      "debug": _vm.chargingStation
    }
  }), _c('Debug', {
    attrs: {
      "debug": _vm.meterReadings
    }
  })], 1)], 1)], 1) : _c('v-container', {
    staticClass: "padded"
  }, [_c('v-row', [_c('v-card', {
    attrs: {
      "flat": "",
      "max-width": "500"
    }
  }, [_c('v-card-text', [_c('a', {
    on: {
      "click": _vm.goToChargingStationOverview
    }
  }, [_c('v-icon', [_vm._v("mdi-menu-left")]), _vm._v("zurück zur Übersicht")], 1), _c('v-skeleton-loader', {
    staticClass: "my-4",
    attrs: {
      "type": "heading"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "text"
    }
  })], 1)], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "offset": "0",
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mb-10"
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "table-heading, table-tbody, table-tfoot"
    }
  })], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }